import React from 'react';
import { get } from 'lodash';
import { handleActions } from 'redux-actions';
import { SET_AVAILABLE_FONTS } from '../../constants/ActionTypes';

const fontsReducerDefaults = {};

const fontsReducer = handleActions(
    {
        [SET_AVAILABLE_FONTS]: (state, action) => {
            return { ...action.fonts };
        }
    },
    fontsReducerDefaults
);

export default fontsReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/fonts.js